import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus("Sending...");

//     try {
//       const res = await fetch("http://localhost:8080/api/contact", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
    //   if (res.ok) {
    //     setStatus("Message sent successfully!");
    //     setForm({ name: "", email: "", company: "", message: "" });
    //   } else {
    //     throw new Error("Failed to send");
    //   }
    // } catch (err) {
    //   setStatus("Error sending message");
    // }
//   };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch("https://opslytic.com/api/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: form.name,
        email: form.email,
        company: form.company,
        message: form.message,
      }),
    });

    const result = await response.json();
    if (response.ok) {
      alert("✅ " + result.message);
    } else {
      alert("❌ " + result.error);
    }
  };

  return (
    <section
      id="contact"
      className="py-20 px-6"
      style={{
        background: "linear-gradient(to bottom right, rgb(37, 31, 141), rgb(14, 11, 66))"
      }}
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-yellow-500 mb-4">Get in Touch</h2>
        <p className="text-white text-center text-2xl mb-6">
          Let us discuss what your requirements are.
        </p>

        <form
          onSubmit={handleSubmit}
          className="grid gap-6 bg-gray-800 p-8 rounded-2xl shadow-2xl"
        >
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            placeholder="Name*"
            autoComplete="off"
            className="p-4 border border-gray-500 bg-gray-700 rounded-lg text-lg text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="Email*"
            autoComplete="off"
            className="p-4 border border-gray-500 bg-gray-700 rounded-lg text-lg text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
          <input
            name="company"
            value={form.company}
            onChange={handleChange}
            placeholder="Company Name"
            autoComplete="off"
            className="p-4 border border-gray-500 bg-gray-700 rounded-lg text-lg text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            rows={5}
            placeholder="Message*"
            className="p-4 border border-gray-500 bg-gray-700 rounded-lg text-lg text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
          ></textarea>

          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 focus:bg-green-800 text-white py-4 px-8 text-lg rounded-xl transition duration-300 ease-in-out"
          >
            Send Message
          </button>

          <p className="text-center text-sm text-gray-300">{status}</p>
        </form>
      </div>
    </section>
  );
}